export default __webpack_public_path__ + "static/media/ontime.ef54b44d.svg";